import React from 'react';
import classNames from 'classnames';
import { Sector } from 'graphql-common';
import LinkComponent, { LinkTypes } from '@lib/components/Link/Link';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import { APP_URLS } from 'constants/urls';
import styles from './SectorMapPopupContent.module.scss';

export default function SectorMapPopupContent({ sector }: { sector?: Sector }) {
  const sectorName = sector?.name;
  const sectorCode = sector?.code;

  const onSectorPageOpen = () => {
    const to = APP_URLS.dashboard.sectors.view.getDynamicPath({
      pathParts: {
        id: `${sector?.id}`,
      },
    });
    window.open(to, '_blank')?.focus();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.sectorNameWrap}>
        {sector?.id ? (
          <LinkComponent
            onClick={onSectorPageOpen}
            type={LinkTypes.tertiaryBlack}
            className={styles.sectorNameLink}
            data-test-id="sector-map-popup__sector-link"
          >
            <Typography variant="body" strong>
              {sectorName}
            </Typography>
          </LinkComponent>
        ) : (
          <Typography variant="body" strong>
            {sectorName}
          </Typography>
        )}
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.infoItemCentered,
          entityViewStyles.infoItemWithLabelIcon,
        )}
      >
        <p className={entityViewStyles.infoItemIconLabel}>
          <MaterialIcon icon="password" symbolsOutlined />
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <Typography variant="body">{sectorCode || '-'}</Typography>
        </div>
      </div>
    </div>
  );
}
